var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.modalSetup === 'pesticide')?_c('AddPesticideFinalStep',{attrs:{"submitMsg":_vm.submitMsg}}):_c('AddExamFinalStep',{attrs:{"submitMsg":_vm.submitMsg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }